import logo from "../images/Charter-Logo.png";
import "./Maintenance.css";

const Maintenance = () => {
  return (
    <main className="maintenance-page">
      <div className="maintenance-orb maintenance-orb-one" />
      <div className="maintenance-orb maintenance-orb-two" />

      <section className="maintenance-card" aria-labelledby="maintenance-title">
        <img
          src={logo}
          className="maintenance-logo"
          alt="Charter Schools"
        />

        <div className="maintenance-illustration" aria-hidden="true">
          <span className="maintenance-gear maintenance-gear-large">⚙</span>
          <span className="maintenance-gear maintenance-gear-small">⚙</span>
          <span className="maintenance-tool">⌁</span>
        </div>

        <div className="maintenance-status">
          <span className="maintenance-status-dot" />
          Scheduled maintenance
        </div>

        <h1 id="maintenance-title">We’ll be back shortly</h1>
        <p className="maintenance-copy">
          Canvas Analyzer Portal is currently undergoing a scheduled upgrade to
          improve your experience. Thank you for your patience while we complete
          the work.
        </p>

        <div className="maintenance-note">
          Please check back again soon. The concerned department will notify you
          once the portal is available.
        </div>

        <footer className="maintenance-footer">
          <span>Canvas Analyzer Portal</span>
          <span className="maintenance-footer-divider" />
          <span>Developed by CTS</span>
        </footer>
      </section>
    </main>
  );
};

export default Maintenance;
